module.exports = __webpack_public_path__ + "static/media/download_illust.70f7bb67.png";